import type { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { Lock as LockIcon } from '@vgno/icons';

import { Button } from '../../../Button/Button';
import { ParentalControlsHeader } from '../../shared/ParentalControlHeader/ParentalControlsHeader';

import * as styles from './Confirmation.module.scss';

interface ConfirmationProps {
  handleClose: () => void;
  handleUnlock: () => void;
}

const Confirmation: FC<ConfirmationProps> = ({ handleClose, handleUnlock }) => {
  const { t } = useTranslation();

  return (
    <>
      <ParentalControlsHeader
        titleText={t('Parental controls activated')}
        subtitleText={t('Change or remove parental controls at any time')}
      />
      <div className={styles.iconContainer}>
        <LockIcon className={styles.icon} />
      </div>
      <Button
        variant="contained"
        size="medium"
        active
        className={styles.button}
        onClick={handleUnlock}
      >
        {t('Remove parental controls')}
      </Button>
      <Button
        variant="contained"
        size="medium"
        active
        className={styles.button}
        onClick={handleClose}
      >
        {t('Close')}
      </Button>
    </>
  );
};

export { Confirmation };
